import { Content, Page404 } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { locations } from '../../utils/locations'

export const NotFound404Root = (): JSX.Element => {
  const { t } = useTranslation()
  const history = useHistory()

  return (
    <Content>
      <Page404
        title={t(`UH OH! You're lost.`)}
        subtitle={t(
          'The page you are looking for does not exist. How you got here is a mystery. But you can click the button below to go back to the homepage.'
        )}
        returnHomeButtonLabel={t('Home page')}
        onReturnHomeClick={() => history.push(locations.home)}
      />
    </Content>
  )
}
